// Shared, governed user-facing strings (design-spec-today-card.md §4's
// copy dictionary: "translate concepts, never surface internal/technical
// terms"). Centralized here so the same phrase is never accidentally
// spelled two different ways across components.

/** Warmer replacement for the old "Unassigned" bucket header (design-qa-
 * sprint-002.md's recommendation) — used anywhere a genuinely unowned
 * cadence chore (`assignee_id: null`) needs a label. */
export const UP_FOR_GRABS_LABEL = "Up for grabs";

/** Sprint-016 F3 (MYL-01) — the phone check-circle's accessible-name
 * pattern (`components/TaskRow.tsx`), centralized so the desktop
 * `DataTable` done column added this sprint (`views/MyListView.tsx`)
 * announces the identical "Mark 'x' done"/"not done" phrasing — one
 * source of truth, not a second hand-typed copy of the same string. */
export function taskDoneAriaLabel(title: string, done: boolean): string {
  return done ? `Mark '${title}' not done` : `Mark '${title}' done`;
}
